import React, { useState, useRef, useEffect } from "react";
import AuthApi from "../../../service/AuthApi";
import { pushNotification } from "../../../utils/notifications";
import ReCAPTCHA from "react-google-recaptcha";

export const KhoiPhucMatKhau = () => {
  const [formData, setFormData] = useState({
    AccountName: "",
    Password: "",
  });
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const recaptchaRef = useRef(null);
  useEffect(() => {
    const originalBodyClass = document.body.className;
    document.body.className =
      "vertical-layout vertical-menu 1-column blank-page page-blue";
    return () => {
      document.body.className = originalBodyClass;
    };
  }, []);
  useEffect(() => {
    document.title = "Khôi phục mật khẩu | Phần mềm quản lý cầm đồ Morman";
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (errors.recaptcha) {
      setErrors((prev) => ({ ...prev, recaptcha: "" }));
    }
    if (errors.api) {
      setErrors((prev) => ({ ...prev, api: "" }));
    }
  };
  const validateForm = () => {
    let formIsValid = true;
    let newErrors = {};

    if (!formData.Password.trim()) {
      newErrors.Password = "Vui lòng nhập thông tin.";
      formIsValid = false;
    }
    if (!formData.PasswordComfirm.trim()) {
      newErrors.PasswordComfirm = "Vui lòng nhập thông tin.";
      formIsValid = false;
    }
    if (formData.Password.trim() != formData.PasswordComfirm.trim()) {
      newErrors.PasswordComfirm = "Mật khẩu không giống nhau.";
      formIsValid = false;
    }
    if (!recaptchaToken) {
      newErrors.recaptcha = "Vui lòng xác nhận bạn không phải robot.";
      formIsValid = false;
    }
    setErrors(newErrors);
    return formIsValid;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    if (!validateForm()) {
      const firstErrorField = Object.keys(errors).find((key) => errors[key]);
      if (firstErrorField) {
        const element = document.getElementsByName(firstErrorField)[0];
        element?.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    const apiData = {
      ...formData,
      RecaptchaToken: recaptchaToken,
      KhoiPhucMatKhauCode: urlParams.get("maxacnhan"),
    };
    setIsLoading(true);

    try {
      const response = await AuthApi.KhoiPhucMatKhau(apiData);
      if (response && response.status === 200) {
        pushNotification(
          "Bạn đã thay đổi mật khẩu thành công!",
          "success",
          "TOP_CENTER",
          3000
        );
        window.location.href = "/dang-nhap.aspx";
      } else {
        const errorMessage =
          response?.data?.message ||
          response?.data ||
          "Thao tác thất bại thất bại. Vui lòng thử lại hoặc liên hệ hỗ trợ.";
        setErrors({ api: errorMessage });
        pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
        if (recaptchaRef.current) recaptchaRef.current.reset();
        setRecaptchaToken(null);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message ||
        err.response?.data ||
        "Đã xảy ra lỗi hệ thống. Vui lòng thử lại.";
      setErrors({ api: errorMessage });
      pushNotification(errorMessage, "error", "TOP_CENTER", 3000);
      if (recaptchaRef.current) {
        recaptchaRef.current.reset();
      }
      setRecaptchaToken(null);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="content">
      <div className="sign-main content-wrapper">
        <div className="content-header row mb-4"></div>
        <div className="content-body">
          <section className="flexbox-container form-login">
            <div className="col-12 d-flex align-items-center justify-content-center">
              <div className="col-md-3 col-10 box-shadow-2 p-0">
                <div className="card border-grey border-lighten-3 m-0">
                  <div className="card-header border-0">
                    <a href="http://morman.vn/">
                      <div className="card-title text-center">
                        <div className="p-1">
                          <img
                            src="/app-assets/images/logo/logo-dark.png"
                            alt="logo"
                          />
                        </div>
                      </div>
                      <h5 className="card-subtitle1 text-center">
                        <span>PHẦN MỀM QUẢN LÝ CẦM ĐỒ SỐ 1 VIỆT NAM</span>
                      </h5>
                      <h6 className="card-subtitle line-on-side text-muted text-center mb-1 pt-2">
                        <span>Vui lòng nhập mật khẩu mới cần thay đổi</span>
                      </h6>
                    </a>
                  </div>
                  <div className="card-content">
                    <div className="card-body">
                      <form
                        onSubmit={handleSubmit}
                        noValidate
                        className="form-horizontal form-simple"
                      >
                        <fieldset className="form-group position-relative has-icon-left mb-1">
                          <input
                            name="Password"
                            type="password"
                            value={formData.Password}
                            onChange={handleInputChange}
                            className={`form-control ${
                              errors.Password ? "is-invalid" : ""
                            }`}
                            placeholder="Mật khẩu"
                            required
                          />
                          <div className="form-control-position">
                            <i className="la la-key"></i>
                          </div>
                          <div className="invalid-feedback red text-left">
                            {errors.Password}
                          </div>
                        </fieldset>
                        <fieldset className="form-group position-relative has-icon-left mb-1">
                          <input
                            name="PasswordComfirm"
                            type="password"
                            value={formData.PasswordComfirm}
                            onChange={handleInputChange}
                            className={`form-control ${
                              errors.PasswordComfirm ? "is-invalid" : ""
                            }`}
                            placeholder="Nhập lại mật khẩu"
                            required
                          />
                          <div className="form-control-position">
                            <i className="la la-key"></i>
                          </div>
                          <div className="invalid-feedback red text-left">
                            {errors.PasswordComfirm}
                          </div>
                        </fieldset>
                        <div className="d-flex justify-content-center my-1">
                          <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey="6LclF-ggAAAAAPseVHjTInekDYaYruu3YFJ24y_P"
                            onChange={handleRecaptchaChange}
                            onExpired={() => {
                              setRecaptchaToken(null);
                              setErrors((prev) => ({
                                ...prev,
                                recaptcha: "Mã CAPTCHA đã hết hạn.",
                              }));
                            }}
                          />
                        </div>
                        <button
                          type="submit"
                          className="btn btn-info btn-lg btn-block"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            <i className="ft-unlock"></i>
                          )}
                          {isLoading ? " Đang xử lý..." : "Thay đổi mật khẩu"}
                        </button>
                      </form>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <p className="text-center text-muted">
                        <a href="/dang-nhap.aspx" className="card-link blue">
                          Đăng nhập
                        </a>
                      </p>
                    </div>
                    <div className="col-lg-8">
                      <p className="text-center text-muted">
                        Bạn là khách hàng mới?{" "}
                        <a
                          href="/dang-ky-dung-thu.aspx"
                          className="card-link blue"
                        >
                          Đăng ký
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
